var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var Dot = /** @class */ (function (_super) {
    __extends(Dot, _super);
    function Dot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dots: 1
        };
        return _this;
    }
    Dot.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, _b = _a.interval, interval = _b === void 0 ? 500 : _b, _c = _a.dots, dots = _c === void 0 ? 3 : _c;
        this.timer = window.setInterval(function () {
            _this.setState({ dots: _this.state.dots === dots ? 1 : _this.state.dots + 1 });
        }, interval);
    };
    Dot.prototype.componentWillUnmount = function () {
        window.clearInterval(this.timer);
    };
    Dot.prototype.render = function () {
        return React.createElement("span", null, Array(this.state.dots).fill('.').join(''));
    };
    return Dot;
}(React.Component));
export default Dot;
